import React from "react";
import styled from "styled-components";
import FooterCol from "./FooterCol";
import PText from "./PText";

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footerBrand{
    font-size:85px;
    font-family: 'Festive', cursive;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align-center;
    padding: 1rem 0;
    margin-top: 5rem;
  }
  .footerImg {
    height: 9rem;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem 0;

    .footerBrand{
      font-size: 70px;
      text-align:center;
        }
    .container {
      padding-left:2rem;
      padding-right:1rem;
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .footerImg {
      height: 7rem;
    }
    .copyright {
      text-align-center;
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  let now = new Date();

  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footerBrand">Sujan SB</h1>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Quick Links"
            links={[
              {
                title: "Home",
                path: "/",
                type: "Link",
              },
              {
                type: "Link",
                title: "About",
                path: "/about",
              },
              {
                type: "Link",
                title: "Projects",
                path: "/projects",
              },
              {
                type: "Link",
                title: "Contact",
                path: "/contact",
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: "sujansharma.ab@gmail.com",
                path: "mailto:sujansharma.ab@gmail.com",
              },
              {
                title: "Bharatpur-11, Chitwan, Nepal",
                path: "http://google.com/maps",
              },
              {
                title: "Phone",
                path: "tel:98650055**",
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Find Me On"
            links={[
              {
                title: "Facebook",
                path: "https://www.facebook.com/profile.php?id=100007043717666",
              },
              {
                title: "Twitter",
                path: "https://twitter.com/sujan_ai",
              },
              {
                title: "Instagram",
                path: "https://www.instagram.com/sujan._sb/",
              },
              {
                title: "LinkedIn",
                path: "https://np.linkedin.com/in/sujan-sharma45",
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>© {now.getFullYear()} - Sujan Sharma</PText>
        </div>
      </div>
    </FooterStyle>
  );
}
